import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../config";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink("Olá! Vim pelo site da Seed Motors e quero atendimento.")}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, type: "spring", stiffness: 200 }}
    className="fixed bottom-6 right-6 z-50 w-16 h-16 rounded-full bg-emerald-500 flex items-center justify-center shadow-[0_0_32px_rgba(16,185,129,0.5)] pulse-ring hover:bg-emerald-400 transition-colors duration-300"
    data-testid="whatsapp-float-button"
    aria-label="WhatsApp"
  >
    <MessageCircle className="w-7 h-7 text-emerald-950" />
    <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-white text-emerald-700 text-[10px] font-bold flex items-center justify-center">
      1
    </span>
  </motion.a>
);
